import {
  Container,
  Wrapper,
  LeftSection,
  Description,
  SocialSection,
  SocialIcons,
  SocialTitle,
  RightSection,
  FormBackground,
  FormBackground2,
  Form,
  InputGroup,
  InputWrapper,
  Label,
  Input,
  Textarea,
  Required,
  SubmitButton,
  FormFooter,
  Heading,
  GradientText,
  BorderBottom,
} from './style';
import { PrismicRichText } from '@prismicio/react';

import Link from 'next/link';
import useContact from 'hooks/useContact';
import { Alert } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
import config from 'config/config';
import Facebook from 'common/assets/image/logo/social/Facebook';
import Twitter from 'common/assets/image/logo/social/twitter';
import Youtube from 'common/assets/image/logo/social/youtube';
import LinkedIn from 'common/assets/image/logo/social/LinkedIn';
/**
 * @typedef {import("@prismicio/client").Content.ContactSlice} ContactSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ContactSlice>} ContactProps
 * @param {ContactProps}
 */
const Contact = ({ slice }) => {
  const {
    valueForm,
    handleChange,
    handleSubmit,
    loading,
    success,
    error,
    handleCaptchaSubmission,
    handleExpiredRecaptcha,
    isVerifiedRecaptcha,
  } = useContact();

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id="contact"
    >
      <Container>
        <Wrapper>
          <LeftSection>
            <Heading data-aos="fade-in">
              <GradientText>{slice.primary.title}</GradientText>
            </Heading>
            <Description data-aos="fade-in">
              <PrismicRichText field={slice.primary.description} />
            </Description>
            <BorderBottom />
            <SocialSection data-aos="fade-in">
              <SocialTitle>{slice.primary.following_us}</SocialTitle>
              <SocialIcons>
                <Link
                  href="https://linkedin.com/company/swiftask"
                  target="_blank"
                >
                  <LinkedIn />
                </Link>
                <Link href="https://x.com/swiftask_ai" target="_blank">
                  <Twitter />
                </Link>
                <Link href="https://www.youtube.com/@Swiftask" target="_blank">
                  <Youtube />
                </Link>

                <Link href="https://www.facebook.com/swiftask" target="_blank">
                  <Facebook />
                </Link>
              </SocialIcons>
            </SocialSection>
          </LeftSection>
          <RightSection data-aos="fade-in">
            <FormBackground />
            <FormBackground2 />
            <Form onSubmit={handleSubmit}>
              {success ? (
                <Alert severity="success">
                  {slice.primary.success_message}
                </Alert>
              ) : null}
              {error ? (
                <Alert severity="error">{slice.primary.error_message}</Alert>
              ) : null}
              <InputGroup>
                <InputWrapper>
                  <Label htmlFor="name">
                    {slice.primary.name} <Required>*</Required>
                  </Label>
                  <Input
                    id="name"
                    placeholder={slice.primary.name_placeholder}
                    required
                    value={valueForm?.name || ''}
                    onChange={handleChange}
                    name="name"
                  />
                </InputWrapper>
                <InputWrapper>
                  <Label htmlFor="email">
                    {slice.primary.e_mail} <Required>*</Required>
                  </Label>
                  <Input
                    id="email"
                    placeholder={slice.primary.email_placeholder}
                    required
                    value={valueForm?.email || ''}
                    onChange={handleChange}
                    name="email"
                  />
                </InputWrapper>
              </InputGroup>
              <InputGroup>
              {/*  */}
                <InputWrapper>
                  <Label htmlFor="email">
                    {slice.primary.numero_telephone} <Required>*</Required>
                  </Label>
                  <Input
                    id="phone"
                    placeholder={slice.primary.placeholder_telephone}
                    required
                    value={valueForm?.phone || ''}
                    onChange={handleChange}
                    name="phone"
                  />
                </InputWrapper>
                {/*  */}
                <InputWrapper>
                  <Label htmlFor="company">
                    {slice.primary.company_name} <Required>*</Required>
                  </Label>
                  <Input
                    id="company"
                    placeholder={slice.primary.company_name_placeholder}
                    required
                    value={valueForm?.company || ''}
                    onChange={handleChange}
                    name="company"
                  />
                </InputWrapper>
              </InputGroup>
              <InputGroup>
                <InputWrapper>
                  <Label htmlFor="size">
                    {slice.primary.size_of_company}
                    <Required>*</Required>
                  </Label>
                  <Input
                    id="size"
                    placeholder={slice.primary.size_of_company_placeholder}
                    required
                    value={valueForm?.size || ''}
                    onChange={handleChange}
                    name="size"
                  />
                </InputWrapper>
                <InputWrapper>
                  <Label htmlFor="sector">
                    {slice.primary.sector_of_activity}
                    <Required>*</Required>
                  </Label>
                  <Input
                    id="sector"
                    placeholder={slice.primary.sector_of_activity_placeholder}
                    required
                    value={valueForm?.sector || ''}
                    onChange={handleChange}
                    name="sector"
                  />
                </InputWrapper>
              </InputGroup>

              <InputWrapper>
                <Label htmlFor="message">
                  {slice.primary.specific_request}
                  <Required>*</Required>
                </Label>
                <Textarea
                  id="message"
                  placeholder={slice.primary.specific_request_placeholder}
                  required
                  value={valueForm?.message || ''}
                  onChange={handleChange}
                  name="message"
                />
              </InputWrapper>
              {/* <ReCAPTCHA
                sitekey={config.recaptchaSiteKey}
                onChange={handleCaptchaSubmission}
                onExpired={handleExpiredRecaptcha}
              /> */}
              <SubmitButton type="submit" disabled={!isVerifiedRecaptcha}>
                {loading
                  ? slice.primary.button_loading
                  : slice.primary.button_send}
              </SubmitButton>

              <FormFooter>{slice.primary.noticed}</FormFooter>
            </Form>
          </RightSection>
        </Wrapper>
      </Container>
    </section>
  );
};

export default Contact;
